export function formatLiChengAmount(value, emptyText = '-') {
  if (value === null || value === undefined || value === '') return emptyText
  const amountInCents = Number(value)
  if (!Number.isFinite(amountInCents)) return emptyText
  return `¥${(amountInCents / 100).toFixed(2)}`
}
